export default __webpack_public_path__ + "static/media/commuter-cover.fbde64fe.png";